import history from 'shared/util/routing/history'

export function goToCompany(id: string) {
  return history.push(`/people/companies/${encodeURIComponent(id)}`)
}
